import { createSelector } from '@reduxjs/toolkit';
import { getBidIncrementsByItemId } from './bidIncrements/bidIncrements.selectors';
import { getItemSummary } from './item/summary/itemSummary.selectors';
import { ItemSummary } from '@/types/item/ItemSummary';
// Using native Array.prototype.findIndex
// Using native Array.prototype.findLast

const getBidderMaxBid = createSelector(getItemSummary, (item) => {
    return item.bidderMaxBid ? item.bidderMaxBid : 0;
});

const getLeadingBid = createSelector(getItemSummary, (item) => {
    return item.leadingBid ? item.leadingBid : 0;
});

const getIsAvailable = createSelector(getItemSummary, (item) => {
    return item.isAvailable !== undefined ? item.isAvailable : false;
});

export const getBidOptions = createSelector(
    [getItemSummary, getBidIncrementsByItemId, getLeadingBid, getBidderMaxBid, getIsAvailable],
    (item: ItemSummary, bidIncrements, leadingBid, bidderMaxBid, isAvailable) => {
        const { startPrice } = item;

        if (!isAvailable || !bidIncrements.length) {
            return [];
        }

        const start = Math.max(leadingBid, startPrice, bidderMaxBid);
        const startIncrement = bidIncrements.findLast((increment) => increment.fromAmount <= start);

        const bidOptions: number[] = [];
        if (!startIncrement) {
            return bidOptions;
        }

        for (let i = startIncrement.fromAmount; bidOptions.length < 600; ) {
            const bidIncrement = bidIncrements.findLast((increment) => {
                return increment.fromAmount <= i;
            });
            i += bidIncrement?.incAmount;

            const indexOfIncrement = bidIncrements.findIndex((increment: any) => {
                return (
                    increment.incAmount === bidIncrement?.incAmount && increment.fromAmount === bidIncrement?.fromAmount
                );
            });

            let nextIncrement;
            if (indexOfIncrement + 1 <= bidIncrements.length) {
                nextIncrement = bidIncrements[indexOfIncrement + 1];
            }

            if (nextIncrement && nextIncrement.fromAmount < i) {
                i = nextIncrement.fromAmount;
            }

            bidOptions.push(i);
        }

        let index =
            !leadingBid && !bidderMaxBid
                ? bidOptions.indexOf(startPrice)
                : bidOptions.indexOf(bidOptions.find((inc) => inc > start));
        if (index === -1) {
            // if the index is -1 then the startPrice wasnt found in the bid options and needs to be added.
            index = 0;
            bidOptions.unshift(startPrice);
        }
        return bidOptions.slice(index).slice(0, 50);
    }
);
